import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const ContractTypeDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [contractTypeOptions, setContractTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { contractTypes, setContractTypes } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setContractTypes(
      parameters?.data?.filter((item) => item.type === "contractType")
    );
  }, [parameters]);

  useEffect(() => {
    setContractTypeOptions(
      contractTypes.map((item: Parameter) => ({
        label: item.value,
        value: item.value,
      }))
    );
  }, [contractTypes]);

  return (
    <Dropdown
      value={options.value}
      options={contractTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo de contrato"
      showClear
    />
  );
};
export default ContractTypeDropdown;
